
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fe7d40133a21353a2e3a8872cc4d321a.jpg"
          alt="Latin America Procurement"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Smarter Sourcing.<br /><span className="text-yellow-400">Better Margins.</span>
          </h1>
          <p className="text-lg lg:text-xl text-gray-200 mb-10 leading-relaxed">
            We help U.S. importers, exporters, manufacturers, and distributors unlock the full potential of Latin American supply chains — from supplier sourcing to landed cost optimization
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-orange-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-orange-700 transition-all hover:-translate-y-1 shadow-lg whitespace-nowrap"
            >
              Schedule Consultation
            </button>
            <button
              onClick={() => scrollToSection('case-studies')}
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white hover:text-gray-900 transition-all hover:-translate-y-1 whitespace-nowrap"
            >
              View Case Studies
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
